<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
			<div class="col-lg-6 col-7">
				<h6 class="h2 text-white d-inline-block mb-0"> {{ $t("menu.invoice") }} </h6>
			</div>
			<div class="col-lg-6 col-5 text-right">
				<base-button size="md" type="neutral" @click="handleCreateBilling()">{{ $t("new") }}</base-button>
			</div>
        </div>

    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">{{ $t("menu.invoice") }}</h3>
            <!-- Filter row 1 — due round, month, year, person -->
            <div class="row">
              <div class="col-md-2">
                <base-input :label="$t('lmg.due_round')">
                  <el-select
                    v-model="searchParams.dueRound"
                    :placeholder="$t('lmg.due_round')"
                  >
                    <el-option
                      v-for="option in dueRoundOptions"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="col-md-2">
                <base-input :label="$t('lmg.month')">
                  <el-select
                    v-model="searchParams.dueMonth"
                    :placeholder="$t('lmg.month')"
                  >
                    <el-option
                      v-for="option in monthOptions"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="col-md-2">
                <base-input :label="$t('lmg.year')">
                  <el-select
                    v-model="searchParams.dueYear"
                    :placeholder="$t('lmg.year')"
                  >
                    <el-option
                      v-for="option in yearOptions"
                      :key="option"
                      :label="option"
                      :value="option"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input :label="$t('lmg.person')">
                  <el-select
                    v-model="searchParams.personId"
                    :placeholder="$t('lmg.person')"
					filterable=""
                  >
                    <el-option
                      v-for="option in PersonTable"
                      :key="option.ID"
                      :label="option.FName + ' ' + option.LName"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <!-- Filter row 2 — status, invoice number, search button (right-aligned) -->
            <div class="row">
              <div class="col-md-2">
                <base-input :label="$t('status')">
                  <el-select
                    v-model="searchParams.status"
                    :placeholder="$t('status')"
                  >
                    <el-option
                      v-for="option in InvoiceStatus"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input
                    :label="$t('lmg.invoice_number')"
                    v-model="searchParams.invoiceNumber"
                    :placeholder="$t('lmg.invoice_number')">
                </base-input>
              </div>

              <div class="col-md-7 d-flex align-items-end justify-content-end">
                <base-button
                  size="md"
                  type="primary"
                  class="mb-3"
                  :disabled="isLoading"
                  @click="listData(params)"
                >
                  <i class="fas fa-spinner fa-spin mr-1" v-if="isLoading"></i>
                  <i class="fas fa-search mr-1" v-else></i>
                  {{ $t("search") }}
                </base-button>
              </div>

            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >

  <!-- {
    "ID": 3,
    "BranchID": 3,
    "PersonID": 2,
    "PersonFName": "น้ำผึ้ง",
    "PersonLName": "เดือนห้า",
    "InvoiceNumber": "4/12/65",
    "Status": 2,
    "BillingList": "{\"BillingList\":[50,51,52],\"Note\":\"ใบวางบิลคุณสมร\"}",
    "BillingListSt": {
      "BillingList": null,
      "Note": ""
    },
    "Amount": 67366,
    "AmountAll": 0,
    "CommissionPercent": 0,
    "CommissionAmount": 0,
    "TaxPercent": 0,
    "TaxAmount": 0,
    "NetAmount": 0,
    "PayAmount": 0,
    "RecorderPersonID": 11,
    "CreatedAt": "2022-12-28T08:26:29+07:00",
    "UpdatedAt": "2023-01-06T15:17:35+07:00",
    "PaidAt": "2023-01-06T12:50:30+07:00",
    "Note": "ใบวางบิลคุณสมร",
    "Filename": "",
    "PaymentVia": 1,
    "PaymentBankID": 1,
    "TranferImage": "TF_INVOICE-20230106151734.png",
    "CreatedAtShow": "2022-12-28 08:26:29",
    "UpdatedAtShow": "2023-01-06 15:17:35",
    "PaidAtShow": "2023-01-06 12:50:30"
  } -->

            

              <el-table-column :label="$t(`lmg.person`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.PersonFName }} {{ row.PersonLName }}
                </div>
              </el-table-column>


              <el-table-column :label="$t(`lmg.invoice_number`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.InvoiceNumber }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`lmg.invoice_pay_amount`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  <!-- {{ row.Amount }} -->
                  {{ FormatCurrency(row.PayAmount) }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`lmg.paid_status`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ getPaidStatus(row.Status) }}
                </div>
              </el-table-column>

			  <el-table-column :label="$t(`created_at`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.CreatedAtShow }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`actions`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">

                  <base-button
                    @click.native="handleViewDetail(row)"
                    class="edit"
                    type="info"
                    size="sm"
                    icon
                    :title="$t('lmg.view_detail')"
                  >
                    <i class="fas fa-eye"></i>
                  </base-button>

					<base-button
                    @click.native="handlePDFBilling(row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                    :title="$t('menu.trans')"
                  >
                    <i class="text-dtac-bt fa fa-download"></i>
                  </base-button>


                   <base-button
                      @click.native="handlePaidBilling(row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
					  v-if="row.Status == 1"
                    :title="$t('lmg.payment')"
                    >
                      <i class="fas fa-dollar-sign"></i>

                    </base-button>

                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="tableData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>




	<!-- Modal Detail -->
    <modal
      :show.sync="showDetailModal"
      modal-classes="modal-secondary modal-lg"
    >
      <div class="invoice-detail">
        <!-- Header -->
        <div class="detail-header">
          <div>
            <h4>
              <i class="fas fa-file-invoice mr-2"></i>{{ $t("lmg.invoice") }}
              <span class="detail-id">{{ detail.InvoiceNumber || ('#' + detail.ID) }}</span>
            </h4>
          </div>
          <div class="d-flex align-items-center">
            <span :class="getPaidStatusClass(detail.Status)" class="mr-2">
              <i class="fas fa-check-circle" v-if="detail.Status == 2"></i>
              <i class="fas fa-clock"         v-else-if="detail.Status == 1"></i>
              <i class="fas fa-ban"           v-else-if="detail.Status == 3"></i>
              {{ getPaidStatus(detail.Status) }}
            </span>
            <base-button
              size="sm"
              type="warning"
              :title="$t('download')"
              @click="handlePDFBilling(detail)"
            >
              <i class="fas fa-download mr-1"></i>PDF
            </base-button>
          </div>
        </div>

        <!-- SECTION: Invoice info -->
        <div class="detail-section">
          <div class="detail-section-header"><i class="fas fa-info-circle"></i>{{ $t('lmg.invoice_number') }}</div>
          <div class="row">
            <div class="col-lg-4">
              <base-input :label="$t('lmg.invoice_number')" :value="detail.InvoiceNumber" readonly></base-input>
            </div>
            <div class="col-lg-4">
              <base-input :label="$t('lmg.person')" :value="(detail.PersonFName || '') + ' ' + (detail.PersonLName || '')" readonly></base-input>
            </div>
            <div class="col-lg-4">
              <base-input :label="$t('lmg.tel')" :value="detail.PersonTel || '-'" readonly></base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <base-input :label="$t('created_at')" :value="detail.CreatedAtShow || '-'" readonly></base-input>
            </div>
            <div class="col-lg-4">
              <base-input :label="$t('lmg.updated_at')" :value="detail.UpdatedAtShow || '-'" readonly></base-input>
            </div>
            <div class="col-lg-4">
              <base-input :label="$t('lmg.paid_date')" :value="detail.PaidAtShow || '-'" readonly></base-input>
            </div>
          </div>
        </div>

        <!-- SECTION: Financial breakdown -->
        <div class="detail-section detail-section--financial">
          <div class="detail-section-header"><i class="fas fa-coins"></i>{{ $t('lmg.invoice_amount') }}</div>
          <div class="row">
            <div class="col-lg-3">
              <base-input :label="$t('lmg.invoice_amount')" :value="FormatCurrency(detail.Amount)" readonly></base-input>
            </div>
            <div class="col-lg-3">
              <base-input :label="$t('lmg.invoice_amount_all')" :value="FormatCurrency(detail.AmountAll)" readonly></base-input>
            </div>
            <div class="col-lg-3">
              <base-input :label="$t('lmg.tax_amount')" :value="FormatCurrency(detail.TaxAmount)" readonly></base-input>
            </div>
            <div class="col-lg-3">
              <base-input :label="$t('lmg.discount')" :value="FormatCurrency(detail.CommissionAmount)" readonly></base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <base-input :label="$t('lmg.net_amount')" :value="FormatCurrency(detail.NetAmount)" readonly></base-input>
            </div>
            <div class="col-lg-3">
              <base-input :label="$t('lmg.invoice_pay_amount')" :value="FormatCurrency(detail.PayAmount)" readonly></base-input>
            </div>
            <div class="col-lg-3">
              <base-input :label="$t('lmg.commission_percent')" :value="(detail.CommissionPercent || 0) + ' %'" readonly></base-input>
            </div>
            <div class="col-lg-3">
              <base-input :label="$t('lmg.tax_percent')" :value="(detail.TaxPercent || 0) + ' %'" readonly></base-input>
            </div>
          </div>
        </div>

        <!-- SECTION: Payment info (only when paid) -->
        <div class="detail-section" v-if="detail.Status == 2">
          <div class="detail-section-header"><i class="fas fa-money-check-alt"></i>{{ $t('lmg.payment') }}</div>
          <div class="row">
            <div class="col-lg-4">
              <base-input :label="$t('lmg.paid_via')" :value="getPaymentViaName(detail.PaymentVia)" readonly></base-input>
            </div>
            <div class="col-lg-4">
              <base-input :label="$t('lmg.bank')" :value="getBankName(detail.PaymentBankID)" readonly></base-input>
            </div>
            <div class="col-lg-4">
              <base-input :label="$t('lmg.paid_date')" :value="detail.PaidAtShow || '-'" readonly></base-input>
            </div>
          </div>
          <div class="row" v-if="detail.TranferImage">
            <div class="col-lg-12">
              <label class="form-control-label">{{ $t('lmg.tranfer_image') }}</label>
              <div>
                <base-button size="sm" type="info" @click="handleViewInvoiceImage()">
                  <i class="fas fa-image mr-1"></i>{{ detail.TranferImage }}
                </base-button>
              </div>
            </div>
          </div>
        </div>

        <!-- SECTION: Covered billings — list of policy numbers in this invoice. -->
        <!-- Each row links into the transaction list pre-filtered by policy_number. -->
        <div class="detail-section" v-if="invoiceBillings && invoiceBillings.length">
          <div class="detail-section-header">
            <i class="fas fa-list"></i>{{ $t('lmg.sale_list') }} ({{ invoiceBillings.length }})
          </div>
          <el-table
            :data="invoiceBillings"
            row-key="billing_id"
            header-row-class-name="thead-light"
            v-loading="isLoadingInvoiceBillings"
            size="mini"
          >
            <el-table-column :label="$t('lmg.policy_number')" min-width="180">
              <template slot-scope="{ row }">
                <a href="#" class="text-primary mr-2" @click.prevent="handlePolicyClick(row)">
                  {{ row.policy_number || ('#' + row.transaction_id) }}
                </a>
                <base-button
                  v-if="row.policy_number"
                  size="sm"
                  type="secondary"
                  :title="$t('copy')"
                  @click="handleCopyPolicyNumber(row.policy_number)"
                >
                  <i class="fas fa-copy"></i>
                </base-button>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lmg.customer')" min-width="180">
              <template slot-scope="{ row }">
                {{ row.customer_fname }} {{ row.customer_lname }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lmg.owner_person')" min-width="180">
              <template slot-scope="{ row }">
                {{ row.owner_fname }} {{ row.owner_lname }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lmg.trans_type')" min-width="110">
              <template slot-scope="{ row }">
                <span class="badge" :class="row.renew == 2 ? 'badge-warning' : 'badge-success'">
                  {{ row.renew == 2 ? "งานต่ออายุ" : "งานใหม่" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lmg.invoice_amount')" min-width="120" align="right">
              <template slot-scope="{ row }">{{ FormatCurrency(row.amount) }}</template>
            </el-table-column>
            <el-table-column :label="$t('lmg.due_date')" min-width="110">
              <template slot-scope="{ row }">{{ row.DueDateShow }}</template>
            </el-table-column>
          </el-table>
        </div>

        <!-- SECTION: Note -->
        <div class="detail-section" v-if="detail.Note">
          <div class="detail-section-header"><i class="fas fa-sticky-note"></i>{{ $t('lmg.note') }}</div>
          <div class="row">
            <div class="col-lg-12">
              <base-input :value="detail.Note" readonly></base-input>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showDetailModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

	<!-- Modal billing -->
    <modal
      :show.sync="showBillingModal"
      modal-classes="modal-secondary modal-lg"
    >
	<!-- header -->
		<div class="row">
			<div class="col-md-12">
				<h1 class="modal-title">
				<i class="fas fa-file-invoice-dollar"></i>
				{{ $t("lmg.billing") }}
				</h1>
			</div>
		</div>
		<!-- Filter row 1 — person + policy + customer + owner names -->
		<div class="row mt-3">
			<div class="col-md-3">
                <base-input :label="$t('lmg.person')">
                  <el-select
                    v-model="paramsBillingCreate.PersonID"
                    :placeholder="$t('lmg.person')"
					filterable=""
                  >
                    <el-option
                      v-for="option in PersonTable"
                      :key="option.ID"
                      :label="option.FName + ' ' + option.LName"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
			</div>

			<div class="col-md-3">
                <base-input
                    :label="$t('lmg.policy_number')"
                    v-model="paramsBillingCreate.PolicyNumber"
                    :placeholder="$t('lmg.policy_number')">
                </base-input>
			</div>

			<div class="col-md-3">
                <base-input
                    :label="$t('lmg.customer')"
                    v-model="paramsBillingCreate.CustomerName"
                    :placeholder="$t('lmg.customer')">
                </base-input>
			</div>

			<div class="col-md-3">
                <base-input
                    :label="$t('lmg.owner_person')"
                    v-model="paramsBillingCreate.OwnerPersonName"
                    :placeholder="$t('lmg.owner_person')">
                </base-input>
			</div>
		</div>

		<!-- Filter row 2 — renew type + due round/month/year -->
		<div class="row">
			<div class="col-md-3">
                <base-input :label="$t('lmg.trans_type')">
                  <el-select
                    v-model="paramsBillingCreate.Renew"
                    :placeholder="$t('lmg.trans_type')"
                  >
                    <el-option
                      v-for="option in renewOptions"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
			</div>

			<div class="col-md-3">
				<base-input :label="$t('lmg.due_round')">
					<el-select
						v-model="paramsBillingCreate.DueRound"
						:placeholder="$t('lmg.due_round')"
					>
						<el-option
							v-for="option in dueRoundOptions"
							:key="option.ID"
							:label="option.Name"
							:value="option.ID"
						>
						</el-option>
					</el-select>
				</base-input>
			</div>

			<div class="col-md-3">
				<base-input :label="$t('lmg.month')">
					<el-select
						v-model="paramsBillingCreate.DueMonth"
						:placeholder="$t('lmg.month')"
					>
						<el-option
							v-for="option in monthOptions"
							:key="option.ID"
							:label="option.Name"
							:value="option.ID"
						>
						</el-option>
					</el-select>
				</base-input>
			</div>

			<div class="col-md-3">
				<base-input :label="$t('lmg.year')">
					<el-select
						v-model="paramsBillingCreate.DueYear"
						:placeholder="$t('lmg.year')"
					>
						<el-option
							v-for="option in yearOptions"
							:key="option"
							:label="option"
							:value="option"
						>
						</el-option>
					</el-select>
				</base-input>
			</div>
		</div>

		<!-- Filter row 3 — search button -->
		<div class="row mb-3">
			<div class="col-md-12 text-right">
				<base-button
                  size="md"
                  type="primary"
                  :disabled="isLoadingBilling"
                  @click="listBilling(paramsBillingCreate)"
                  >
                  <i class="fas fa-spinner fa-spin mr-1" v-if="isLoadingBilling"></i>
                  <i class="fas fa-search mr-1" v-else></i>
                  {{ $t("search") }}
                </base-button>
			</div>
		</div>

	


		<el-table
        :data="tableBilling"
        row-key="id"
        header-row-class-name="thead-light"
		@selection-change="onSelectionChange">
        <!-- Record paidvia   note bank amount -->
		<el-table-column type="selection"
                       align="left"
                       min-width="120px">
      </el-table-column>
		<el-table-column :label="$t('lmg.customer')">
          <template slot-scope="{ row }">
			{{ row.customer_fname }} {{ row.customer_lname }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.owner_person')">
          <template slot-scope="{ row }">
			{{ row.owner_fname }} {{ row.owner_lname }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.policy_number')">
          <template slot-scope="{ row }">
			{{ row.policy_number }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('lmg.trans_type')">
          <template slot-scope="{ row }">
			<span class="badge" :class="row.renew == 2 ? 'badge-warning' : 'badge-success'">
				{{ row.renew == 2 ? "งานต่ออายุ" : "งานใหม่" }}
			</span>
          </template>
        </el-table-column>

		<!-- amount -->
		<el-table-column :label="$t('lmg.invoice_amount')">
		  <template slot-scope="{ row }">
			{{ FormatCurrency(row.amount) }}
			</template>	
		</el-table-column>

		<el-table-column :label="$t('lmg.invoice_amount_all')">
		  <template slot-scope="{ row }">
			{{ FormatCurrency(row.amount_all) }}
			</template>	
		</el-table-column>

        <el-table-column :label="$t('created_at')">
          <template slot-scope="{ row }">
			{{ row.CreatedAtShow }}
          </template>
        </el-table-column>

		<el-table-column :label="$t('lmg.due_date')">
          <template slot-scope="{ row }">
			{{ row.DueDateShow }}
          </template>
        </el-table-column>
		</el-table>

		<div class="row mt-3">
			<div class="col-lg-12">
				<base-input
					:label="$t('lmg.note')"
					v-model="paramsBilling.Note"
				></base-input>
			</div>
		</div>

      <template slot="footer">
		<button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdateBilling()"
        >
          {{ $t("save") }}
        </button>

        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showBillingModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>



	<!-- Modal Paid -->
    <modal
      :show.sync="showPaidModal"
      modal-classes="modal-secondary modal-lg"
    >
	<validation-observer  ref="formValidator">
	<!-- Payment Via , PaymentBank -->
	<div class="row">
		<div class="col-lg-6">

        <base-input
          :label="$t('lmg.billing_paid_via')"
          :name="$t('lmg.billing_paid_via')"
          input-classes="form-control-alternative new-event--title"
		  rules="required"
        >
          <el-select
            v-model="paramsPaid.PaymentVia"
            :placeholder="$t('lmg.billing_paid_via')"
          >
            <el-option
              v-for="option in paidType"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>
		</div>
	</div>
	<div class="row" v-if="paramsPaid.PaymentVia == 3">
		<div class="col-lg-6">
		<base-input
          :label="$t('lmg.bank')"
          :name="$t('lmg.bank')"
          input-classes="form-control-alternative new-event--title"
		  rules="required"
        >
          <el-select v-model="paramsPaid.PaymentBankID" :placeholder="$t('lmg.bank')">
            <el-option
              v-for="option in tableBank"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>
		</div>
      </div>
	  


	  <div class="row">
			<div class="col-lg-6">
              <base-input
                :label="$t('lmg.paid_file')"
                :name="$t('lmg.paid_file')"
                input-classes="form-control-alternative new-event--title"
              >
                <file-input @change="filesChange"></file-input>
              </base-input>
            </div>
			</div>

		<div class="row">
		<div class="col-lg-6">
			<base-input
                :label="$t('lmg.paid_time')"
                :name="$t('lmg.paid_time')"
				rules="required"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  class="form-control datepicker"
                  v-model="paramsPaid.PaidDate"
				  :config="formatDate"
                >
                </flat-picker>
              </base-input>
		</div>
	  </div>
	</validation-observer>




	  <template slot="footer">
		<button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdatePaid()"
        >
          {{ $t("save") }}
        </button>

        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showPaidModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>


  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/BillingPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  mixins: [clientPaginationMixin],
  components: {
    flatPicker,
    BasePagination,
    RouteBreadCrumb,
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
		tableData: "Invoice/getData",
		tableBilling: "Invoice/getBilling",
		invoiceBillings: "Invoice/getInvoiceBillings",
		InvoiceStatus: "Invoice/getInvoiceStatus",
		PersonTableOrg: "Person/getData",
		tableBank: "Bank/getData",
		isLoading: "Invoice/isLoading",
		isLoadingBilling: "Invoice/isLoadingBilling",
		isLoadingInvoiceBillings: "Invoice/isLoadingInvoiceBillings",
    }),
	PersonTable : function(){
		return [{ID:0,FName:"ทั้งหมด",LName:""},...this.PersonTableOrg];
	},
	yearOptions : function(){
		const currentYear = new Date().getFullYear();
		const years = [];
		for (let y = currentYear - 2; y <= currentYear + 1; y++) {
			years.push(y);
		}
		return years;
	},
	params : function(){
		return {
			DueRound : this.searchParams.dueRound,
			DueMonth : this.searchParams.dueMonth,
			DueYear : this.searchParams.dueYear,
			PersonID : this.searchParams.personId == "" ? 0 : this.searchParams.personId,
			Status : this.searchParams.status,
			InvoiceNumber : this.searchParams.invoiceNumber,
		};
	},
  },
  data() {
    return {
      propsToSearch: ["Name", "AcountNumber"],
      selectedRows: [],
      showBillingModal: false,
      showPaidModal: false,
      showDetailModal: false,
      detail: {},
	  paidType: [
        { ID: 1, Name: "เงินสด" },
        { ID: 2, Name: "เช็ค" },
        { ID: 3, Name: "โอนเงิน" }
      ],

      searchParams: {
        dueRound: 0,
        dueMonth: new Date().getMonth() + 1,
        dueYear: new Date().getFullYear(),
        personId: "", //1=DESC
        status: 0, //1 รอชำระเงิน, 2 ชำระเงินแล้ว, 3 ยกเลิก
        invoiceNumber:"",
      },
	  paramsBilling:{
		Note:"",
		BillingList:[],
	  },
	  paramsPaid:{
		ID : "",
		PaymentVia : "",
		PaymentBankID : "",
		Tfimg : "",
		PaidDate : "",
	  },
	  paramsBillingCreate:{
		PersonID:0,
		PolicyNumber:"",
		CustomerName:"",
		OwnerPersonName:"",
		Renew:0, // 0 all, 1 งานใหม่, 2 งานต่ออายุ
		DueRound: 0,
		DueMonth: new Date().getMonth() + 1,
		DueYear: new Date().getFullYear(),
	  },
	  renewOptions: [
		{ ID: 0, Name: "ทั้งหมด" },
		{ ID: 1, Name: "งานใหม่" },
		{ ID: 2, Name: "งานต่ออายุ" },
	  ],
	  dueRoundOptions: [
		{ ID: 0, Name: "ไม่เลือก" },
		{ ID: 1, Name: "รอบที่ 1 (วันที่ 15)" },
		{ ID: 2, Name: "รอบที่ 2 (สิ้นเดือน)" },
	  ],
	  monthOptions: [
		{ ID: 1, Name: "มกราคม" },
		{ ID: 2, Name: "กุมภาพันธ์" },
		{ ID: 3, Name: "มีนาคม" },
		{ ID: 4, Name: "เมษายน" },
		{ ID: 5, Name: "พฤษภาคม" },
		{ ID: 6, Name: "มิถุนายน" },
		{ ID: 7, Name: "กรกฎาคม" },
		{ ID: 8, Name: "สิงหาคม" },
		{ ID: 9, Name: "กันยายน" },
		{ ID: 10, Name: "ตุลาคม" },
		{ ID: 11, Name: "พฤศจิกายน" },
		{ ID: 12, Name: "ธันวาคม" },
	  ],
	  formatDate: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
    },

    };
  },
  async mounted() {
	this.listPerson();
	this.listBank();
    await this.listData(this.params);
  },
  methods: {
    ...mapActions({
      createData: "Invoice/createData",
      paidData: "Invoice/paidData",
      reportData: "Invoice/reportData",
      listData: "Invoice/listData",
      listBilling: "Invoice/listBilling",
      clearBilling: "Invoice/clearBilling",
      listInvoiceBillings: "Invoice/listInvoiceBillings",
      clearInvoiceBillings: "Invoice/clearInvoiceBillings",
      listPerson: "Person/listData",
	  listBank: "Bank/listData",
    }),

	getPaidStatus(t) {
      if (t == null || t === "") return "";
      const s = this.InvoiceStatus.filter(f => f.ID == t);
      return s.length ? s[0].Name : "";
    },
    
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    filesChange(files) {
      this.paramsPaid.Tfimg = files[0];
    },
	handleCreateBilling(){
		this.showBillingModal = true;
		this.clearBilling();
		// Reset filters to their defaults on open
		const today = new Date();
		this.paramsBillingCreate.PersonID = 0;
		this.paramsBillingCreate.PolicyNumber = "";
		this.paramsBillingCreate.CustomerName = "";
		this.paramsBillingCreate.OwnerPersonName = "";
		this.paramsBillingCreate.Renew = 0;
		this.paramsBillingCreate.DueRound = 0;
		this.paramsBillingCreate.DueMonth = today.getMonth() + 1;
		this.paramsBillingCreate.DueYear = today.getFullYear();
	},
	handleUpdateBilling(){
	
		this.paramsBilling.BillingList = [];

		// Add selected rows to paramsBilling.BillingList
		this.selectedRows.map((item) => {
			this.paramsBilling.BillingList.push(item.id);
		});

		// console.log(this.paramsBilling)
		// return

		this.createData(this.paramsBilling)
          .then(resp => {
            this.listData(this.params);
			this.showBillingModal = false;
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: '',
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });

	},

	handlePaidBilling(row){
		this.showPaidModal = true;
		this.paramsPaid.ID = row.ID;

		this.$refs.formValidator.reset();

		// Clear paramsPaid
		this.paramsPaid.PaymentVia = "";
		this.paramsPaid.PaymentBankID = "";
		this.paramsPaid.Tfimg = "";
		this.paramsPaid.PaidDate = "";

	},
	async handleUpdatePaid(){

		try{
			let result = await this.$refs.formValidator.validate();
			if (!result) {
				return;
			}
		} catch (e) {
			console.log(e)
			return
		}
		// check Tfimg
		if(this.paramsPaid.Tfimg == "" && this.paramsPaid.paidType == 3){
			swal.fire({
			  title: this.$t("กรุณาเลือกไฟล์"),
			  text: '',
			  icon: "error",
			  confirmButtonClass: "btn btn-danger btn-fill",
			  buttonsStyling: false
			});
			return
		}


		let formData = new FormData();
        formData.append("ID", this.paramsPaid.ID);
        formData.append("PaymentVia", this.paramsPaid.PaymentVia);
        formData.append("PaymentBankID", this.paramsPaid.PaymentBankID);
        formData.append("Tfimg", this.paramsPaid.Tfimg);
        formData.append("PaidDate", this.paramsPaid.PaidDate);

		this.paidData(formData)
          .then(resp => {
            this.listData(this.params);
			this.showPaidModal = false;
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: '',
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });

	},
	handleViewDetail(row){
		this.detail = row;
		this.showDetailModal = true;
		// Fetch enriched billing rows (policy_number + customer/owner) so the
		// modal can list them as clickable links into the transaction page.
		this.clearInvoiceBillings();
		if (row && row.ID) {
			this.listInvoiceBillings(row.ID);
		}
	},
	handlePolicyClick(row){
		// Open the read-only transaction detail page in a NEW TAB so the
		// invoice modal + filter context stay intact for the user.
		if (!row || !row.transaction_id) return;
		const route = this.$router.resolve({ name: "TransView", params: { id: row.transaction_id } });
		window.open(route.href, "_blank", "noopener");
	},
	async handleCopyPolicyNumber(policyNumber){
		if (!policyNumber) return;
		try {
			// Modern clipboard API. Falls back to a hidden textarea+execCommand
			// for older browsers / non-HTTPS contexts where navigator.clipboard
			// is unavailable.
			if (navigator.clipboard && window.isSecureContext) {
				await navigator.clipboard.writeText(policyNumber);
			} else {
				const ta = document.createElement("textarea");
				ta.value = policyNumber;
				ta.style.position = "fixed";
				ta.style.opacity = "0";
				document.body.appendChild(ta);
				ta.select();
				document.execCommand("copy");
				document.body.removeChild(ta);
			}
			swal.fire({
				toast: true,
				position: "top-end",
				icon: "success",
				title: this.$t("copied") + ": " + policyNumber,
				showConfirmButton: false,
				timer: 1500,
			});
		} catch (e) {
			swal.fire({
				toast: true,
				position: "top-end",
				icon: "error",
				title: this.$t("copy_failed"),
				showConfirmButton: false,
				timer: 2000,
			});
		}
	},
	getPaidStatusClass(status){
		if (status == 1) return "status-pill status-pill--processing";  // รอชำระเงิน
		if (status == 2) return "status-pill status-pill--success";     // ชำระแล้ว
		if (status == 3) return "status-pill status-pill--danger";      // ยกเลิก
		return "status-pill status-pill--muted";
	},
	getPaymentViaName(via){
		const p = this.paidType.find(it => it.ID == via);
		return p ? p.Name : "-";
	},
	getBankName(bankID){
		if (!bankID) return "-";
		const list = this.tableBank || [];
		const b = list.find(it => it.ID == bankID);
		return b ? b.Name : `#${bankID}`;
	},
	handleViewInvoiceImage(){
		if (!this.detail.TranferImage) return;
		const base = process.env.VUE_APP_API_BASE_URL || "";
		window.open(`${base}/api/file/image?FileName=${encodeURIComponent(this.detail.TranferImage)}`, "_blank");
	},
	handlePDFBilling(row){
		this.reportData({InvoiceID : row.ID}).then(res => {
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `invoice-${row.ID}.pdf`); //or any other extension
			document.body.appendChild(link);
			link.click();
		}).catch(err => {
			swal.fire({
			  title: "Error",
			  text: '',
			  icon: "error",
			  confirmButtonClass: "btn btn-danger btn-fill",
			  buttonsStyling: false
			});
		});
	},
	onSelectionChange(selectedRows) {
        this.selectedRows = selectedRows
      },
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}

/* ---- Invoice detail modal styling ---- */
.invoice-detail .detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  background: linear-gradient(135deg, #f5f7fb 0%, #ecf0fb 100%);
  border-left: 4px solid #5e72e4;
}
.invoice-detail .detail-header h4 {
  margin: 0;
  font-weight: 600;
  color: #32325d;
}
.invoice-detail .detail-header .detail-id {
  font-weight: 400;
  color: #8898aa;
  margin-left: 0.5rem;
  font-family: monospace;
}

.invoice-detail .detail-section {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem 0.25rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px rgba(50, 50, 93, 0.04);
}
.invoice-detail .detail-section-header {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8898aa;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed #e9ecef;
}
.invoice-detail .detail-section-header i {
  margin-right: 0.5rem;
  color: #5e72e4;
  font-size: 0.9rem;
}
.invoice-detail .detail-section--financial {
  background: #fafcff;
  border-color: #dfe7f5;
}
.invoice-detail .detail-section--financial .detail-section-header i {
  color: #2dce89;
}

.invoice-detail .status-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.invoice-detail .status-pill i { margin-right: 0.35rem; }
.invoice-detail .status-pill--success    { background: #e6f8ef; color: #1aae6f; }
.invoice-detail .status-pill--processing { background: #fff4e0; color: #c58b00; }
.invoice-detail .status-pill--danger     { background: #fde4e4; color: #d6436a; }
.invoice-detail .status-pill--muted      { background: #eef1f7; color: #525f7f; }

.invoice-detail .form-control[readonly] {
  background-color: #fbfcfe;
  cursor: default;
}

/* billing list chip grid */
.invoice-detail .billing-chip {
  display: inline-block;
  padding: 0.25rem 0.7rem;
  margin: 0.15rem 0.2rem 0.15rem 0;
  background: #eef3ff;
  color: #324cdd;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.8rem;
}
</style>
